// Fallback required by Expo Router when _layout.web.tsx exists.
// Hides the parent "Reports" header and provides a nested Stack so each
// reports screen can configure its own header (title, etc.) on native.
import { Stack } from "expo-router";
import { useUnistyles } from "react-native-unistyles";

export default function ReportsLayout() {
  const { theme } = useUnistyles();

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <Stack
        screenOptions={{
          headerStyle: {
            backgroundColor: theme.colors.background,
          },
          headerTintColor: theme.colors.text,
          headerBackButtonDisplayMode: "minimal",
          contentStyle: {
            backgroundColor: theme.colors.background,
          },
        }}
      />
    </>
  );
}
